import Vue from 'vue';
import jsona from '@/lib/jsona';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import visnetHubFaultElectricalDataImpedance from '@/resources/visnet-hub-fault-electrical-data-impedance';

const MODULE_NAME = 'faultDataImpedance';
const DEFAULT_STATE = { data: {} };

export default {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  namespaced: true,
  state: Object.assign(DEFAULT_STATE, {}),
  mutations: {
    parseResponseData(state, response) {
      const responseParsed = jsona.deserialize(response);

      Vue.set(state, 'data', responseParsed);
    },
    setError(state, error) {
      state.error = error;
    },
    resetFaultPanelData(state) {
      state.data = {};
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    async fetchFaultElectricalDataImpedance({ commit }, visnetParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const {
        externalVisnetHubId,
        projectCode,
        substationCode,
        phaseNumber,
        feederNumber
      } = visnetParams;

      try {
        const response = await visnetHubFaultElectricalDataImpedance({ externalVisnetHubId }).get({
          project_code: projectCode,
          substation_code: substationCode,
          phase_number: phaseNumber,
          feeder_number: feederNumber
        });

        if (!response) throw Error;

        commit('parseResponseData', response.body);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (error) {
        commit('setError', error.body);

        if (error.status === 404) {
          commit('parseResponseData', { data: {} });
        }
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      }
    }
  }
};
